import React, { useEffect, useRef } from "react";
import { defaultFrame, viewOption } from "../../constants";
import { useStore } from "../../store";
import { seekToFrame } from "src/services/animations";

export const Viewer: React.FC<{ modelUid: string }> = ({
  modelUid,
}): JSX.Element => {
  const viewerIframeRef = useRef<HTMLIFrameElement>(null);
  const { setViewIsReady, setApiref } = useStore();

  const ViewerIframe = (
    <iframe
      // We feed the ref to the iframe component to get the underlying DOM object
      ref={viewerIframeRef}
      title="sketchfab-viewer"
      className="c-cytiva__webgl"
      allow="gyroscope;accelerometer;xr-spatial-tracking"
    />
  );

  const success = (api: any) => {
    setApiref(api);
    // api.ui
    api.start(() => {});
    api.load(() => {});

    api.addEventListener("viewerready", function () {
      api.pause(() => {});
      seekToFrame(defaultFrame);
      // api.setFrame(10, () => {});
      api.getCurrentTime(function (err: any, time: number) {
        if (!err) {
          // window.console.log("Current animation time:", time);
        }

        api.getAnimations(function (err: any, animations: any) {
          if (!err) {
            var firstAnimationUID = animations[0][0];
            api.setCurrentAnimationByUID(
              firstAnimationUID,
              function (err: any) {
                if (!err) {
                  // console.log("Set animation track to", firstAnimationUID);
                }
              }
            );
          }
        });
      });

      setViewIsReady(true);
    });
  };

  const error = () => {
    console.log("Viewer error");
  };

  const options = process.env.NODE_ENV === "development" ? {} : viewOption;

  useEffect(() => {
    // Initialize the viewer
    let client = new window.Sketchfab(viewerIframeRef.current);
    client.init(modelUid, {
      success: success,
      error: error,
      ...options,
    });
  }, []);

  return ViewerIframe;
};
